import { render, staticRenderFns } from "./ModalStudyResultImage.vue?vue&type=template&id=6e2f7a31&scoped=true&lang=pug"
import script from "./ModalStudyResultImage.vue?vue&type=script&lang=ts"
export * from "./ModalStudyResultImage.vue?vue&type=script&lang=ts"
import style0 from "./ModalStudyResultImage.vue?vue&type=style&index=0&id=6e2f7a31&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f7a31",
  null
  
)

export default component.exports